import api from "@/plugins/api/EntryPoint";

export default {
  /**
   * Отправка показаний счетчика в API Naftogaz Tariffmax
   * @param {Object} params - Параметры запроса (meterValue, ls, lastname)
   * @param {Function} callBackFn - Функция обратного вызова
   */
  async sendApiNaftogazTariffmaxIndications(params, callBackFn) {
    console.log(
      "sendApiNaftogazTariffmaxIndications: " + JSON.stringify(params)
    );
    await api.post(
      "indication/send-api-naftogas-indication",
      params,
      callBackFn
    );
  },
};
